import axios from "axios";
import React, { createContext, useEffect, useState } from "react";

const Auth = createContext();

function AuthContextProvider(props) {
  const [loggedIn, setLoggedIn] = useState(false);
  const [userData, setUserData] = useState({
    token: undefined,
    user: undefined,
  });

  async function getLoggedIn() {
    const token = localStorage.getItem("auth-token");

    // Token yoksa, kullanıcı çıkış yapmış demektir
    if (!token) {
      setLoggedIn(false);
      setUserData({ token: undefined, user: undefined });
      return;
    }

    try {
      const loggedInRes = await axios.post(
        "https://opt-api.vercel.app/loggedIn",
        null,
        { headers: { "x-auth-token": token } }
      );

      if (loggedInRes.data) {
        const userRes = await axios.get("https://opt-api.vercel.app/log", {
          headers: { "x-auth-token": token },
        });
        setUserData({
          token,
          user: userRes.data,
        })
        setLoggedIn(loggedInRes.data);
      } else {
        setLoggedIn(false);
        setUserData({ token: undefined, user: undefined });
      }
    } catch (error) {
      console.error("Auth check failed:", error);
      setLoggedIn(false);
      setUserData({ token: undefined, user: undefined });
    }
  }

  // Sadece component mount olduğunda kontrol et
  useEffect(() => {
    // App mount olduğunda hemen auth kontrolü yap
    getLoggedIn();

    // Ayrıca storage change event'ini dinle (başka tab'dan logout vb.)
    const handleStorageChange = () => {
      getLoggedIn();
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  return (
    <Auth.Provider
      value={{ userData, setUserData, loggedIn, getLoggedIn, setLoggedIn }}
    >
      {props.children}
    </Auth.Provider>
  );
}

export default Auth;
export { AuthContextProvider };
